/**
 * In-memory, chat-scoped cache of the raw IDOR auth credentials the user submitted.
 *
 * The backend transforms cookie/header UI values into the auth contract and AES-encrypts them into
 * Redis — it never echoes the originals back to the client. So the "Update Credentials" modal has no
 * way to prefill with what the user started with. We stash the raw {cookieAuth, customHeaders} here at
 * every AUTH_CONFIG submit site (fresh IDOR flow, "Run last setup", and the modal's Check Again) and
 * read them back in IDORAuthVerificationWidget.
 *
 * Deliberately in-memory only (cleared on reload) and NOT in redux — keeps credentials out of the
 * redux devtools / persisted chat payloads, matching the existing "nothing stashed client-side" stance.
 */

const store = new Map();

/**
 * @param {string|null|undefined} chatId
 * @param {{ cookieAuth?: string, customHeaders?: Array<{headerName:string, headerValue:string}> }} creds
 */
export function setIdorCreds(chatId, creds) {
  if (!chatId) return;
  store.set(chatId, {
    cookieAuth: creds?.cookieAuth || '',
    customHeaders: Array.isArray(creds?.customHeaders) ? creds.customHeaders : [],
  });
}

/**
 * @param {string|null|undefined} chatId
 * @returns {{ cookieAuth: string, customHeaders: Array }|null}
 */
export function getIdorCreds(chatId) {
  if (!chatId) return null;
  return store.get(chatId) || null;
}
